export default __webpack_public_path__ + "static/media/empty-card.f8d62fe6.svg";